import { createSlice } from '@reduxjs/toolkit'
import { UpdateStateOrderItemAmount } from '../services/last-state-service';

const minOrderItemAmount = 1;
const maxOrderItemAmount = 5;

export const orderItemAmountSlice = createSlice({
  name: 'orderItemAmount',
  initialState: {
    value: minOrderItemAmount,
  },
  reducers: {
    addOrderItem: (state) => {
      if (state.value < maxOrderItemAmount) {
        state.value += 1;
        UpdateStateOrderItemAmount({number: state.value});
      }
    },
    removeOrderItem: (state) => {
      if (state.value > minOrderItemAmount) {
        state.value -= 1;
        UpdateStateOrderItemAmount({number: state.value});
      }
    },
    setOrderItem: (state, action) => {
      if (state.value <= maxOrderItemAmount && state.value >= minOrderItemAmount) {
        state.value = action.payload;
        UpdateStateOrderItemAmount({number: state.value});
      }
    },
  },
})

export const { addOrderItem, removeOrderItem, setOrderItem } = orderItemAmountSlice.actions

export const selectOrderItemAmount = (state) => state.orderItemAmount.value

export default orderItemAmountSlice.reducer
